import React from "react";
import "./challenge-description.css";
import moment from "moment";
import { capitalize, capitalizeAll } from "../../../../../core/utils/helpers";
import { TbTextRecognition } from "react-icons/tb";
import { BsBodyText } from "react-icons/bs";

const ChallengeDescription = ({ data }) => {
  return (
    <div className="challenge-description">
      <div className="details-label">
        <div className="dl-row">
          <TbTextRecognition className="icon" />
          <span>Challenge Title :</span>
        </div>
        <p>{capitalizeAll(data?.title)}</p>
        <p>
          created {moment(data?.dates).fromNow()}; on{" "}
          {moment(data?.dates).format("LLLL")}
        </p>
      </div>
      <div className="details-label">
        <div className="dl-row">
          <BsBodyText className="icon" />
          <span>Challenge Description :</span>
        </div>
        <p>{data?.description}</p>
      </div>
      <hr />
      <div className="details-row">
        <span>Type :</span>
        <span>{data?.type}</span>
      </div>
      <div className="details-row">
        <span>Accessibility :</span>
        <span>{capitalize(data?.accessibility)}</span>
      </div>
      <div className="details-row">
        <span>Allow joining late :</span>
        <span>{data?.allow_joining_late ? "Yes" : "No"}</span>
      </div>
      <div className="details-row">
        <span>Random questions order :</span>
        <span>{data?.random_questions_order ? "Yes" : "No"}</span>
      </div>
      <div className="details-row">
        <span>Automatically move through questions :</span>
        <span>{data?.automatically_move_through_questions ? "Yes" : "No"}</span>
      </div>
      <div className="details-row">
        <span>Stop question on first user answer :</span>
        <span>{data?.stop_question_on_first_user_answer ? "Yes" : "No"}</span>
      </div>
      <div className="details-row">
        <span>Self participation :</span>
        <span>{data?.self_participation ? "Yes" : "No"}</span>
      </div>
      <div className="details-row">
        <span>Total Participants :</span>
        <span>{data?.total_teams * data?.numbers_of_players_per_team}</span>
      </div>
      <div className="details-row">
        <span>Total teams :</span>
        <span>{data?.total_teams}</span>
      </div>
      <div className="details-row">
        <span>Teams breakdown :</span>
        <span>{capitalize(data?.teams_breakdown)}</span>
      </div>
      <div className="details-row">
        <span>Numbers of players per team :</span>
        <span>{data?.numbers_of_players_per_team}</span>
      </div>
      <div className="details-row">
        <span>Joining mode question :</span>
        <span>{data?.joining_mode_question}</span>
      </div>
      <div className="details-row">
        <span>Joining access :</span>
        <span>{capitalize(data?.challenge_joining_access)}</span>
      </div>
      <div className="details-row">
        <span>Allowing nickname :</span>
        <span>{data?.allowing_nickname ? "Yes" : "No"}</span>
      </div>
      <div className="details-row">
        <span>Starting Date :</span>
        <span>{moment(data?.starting_dates).format("lll")}</span>
      </div>
      <div className="details-row">
        <span>Ending Date :</span>
        <span>{moment(data?.ending_dates).format("lll")}</span>
      </div>
    </div>
  );
};

export default ChallengeDescription;
